import { TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { IAuthenticationProvider } from '../services/SiteAuthenticationSettingsService';

export interface ConfirmActionDialogSiteAuthenticationProviderEnableProps {
    aboutToBeDisabled: IAuthenticationProvider[];
    aboutToLockMyselfOut: boolean;
    getProviderDisplayName: (provider: IAuthenticationProvider) => string;
    getHelp: (category?: string) => void;
}

export class ConfirmActionDialogSiteAuthenticationProviderEnable extends React.Component<ConfirmActionDialogSiteAuthenticationProviderEnableProps> {
    constructor(props: ConfirmActionDialogSiteAuthenticationProviderEnableProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="tb-alert-message">
                    {Messages.ssoBeforeYouContinue_text_1()}
                </div>
                <ul>
                    {this.props.aboutToBeDisabled.map((provider) => {
                        return <li key={provider.id}>{this.props.getProviderDisplayName(provider)}</li>;
                    })}
                </ul>
                <div className="tb-alert-message">
                    {Messages.ssoBeforeYouContinue_text_2()}
                    <TextLinkWidget onClick={() => this.props.getHelp('authenticationtypes')} testId='provider-enable-dialog-learn-more-link'>
                        {Messages.ssoLearnMore()}
                    </TextLinkWidget>
                </div>
                <div className="tb-dialog-error">
                    {this.props.aboutToLockMyselfOut
                    ? Messages.ssoBeforeYouContinue_aboutToLockYourselfOut()
                    : null}
                </div>
            </div>
        );
    }
}
